export enum PriceType {
  MonthlyRate = 'monthly_rate',
  PurchasePrice = 'purchase_price',
  EcoBonus = 'eco_bonus',
  EcoBonusDe = 'eco_bonus_de',
  CustomerDiscount = 'customer_discount',
  BasePrice = 'base_price',
  StrikePrice = 'strike_price',
  SubTotalPrice = 'sub_total_price',
  TotalPrice = 'total_price',
  PriceDiscount = 'price_discount',
  PriceReduction = 'price_reduction',
}
